var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1986 69.41C58.1371 69.41 69.0407 52.9375 69.0407 38.6532C69.0407 38.1854 69.0312 37.7197 69.0101 37.2559C71.1315 35.7251 72.9625 33.8296 74.4172 31.6583C72.4749 32.5193 70.3848 33.0989 68.1924 33.3602C70.4302 32.0218 72.1484 29.9049 72.959 27.3812C70.831 28.6401 68.5031 29.5275 66.0757 30.0052C64.0976 27.904 61.2816 26.5898 58.1632 26.5898C52.177 26.5898 47.3227 31.4309 47.3227 37.3982C47.3227 38.2465 47.4179 39.0717 47.6039 39.863C38.5946 39.411 30.6059 35.1095 25.2594 28.5688C24.2965 30.2184 23.7899 32.0933 23.7916 34.002C23.7916 37.7524 25.7053 41.0632 28.6154 43.0001C26.8941 42.9477 25.2105 42.484 23.7061 41.6481C23.7045 41.6935 23.7045 41.7377 23.7045 41.7861C23.7045 47.0213 27.441 51.3923 32.401 52.3827C31.4694 52.6358 30.5082 52.7637 29.5427 52.7632C28.8589 52.7627 28.1767 52.6974 27.5054 52.5682C28.8854 56.8633 32.8872 59.9888 37.6316 60.0762C33.9215 62.9761 29.2478 64.7033 24.1683 64.7033C23.2945 64.7033 22.4312 64.6538 21.5827 64.5537C26.3801 67.6202 32.0766 69.4095 38.1991 69.4095",
    fill: "#EC1C2E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 46.2734,
    stroke: "#EC1C2E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitterIcon.cd945049d996ef425e4705c1936e7692.svg";
export { ForwardRef as ReactComponent };